<template>
  <div id="wxLogin"> {{ message }} </div>
</template>

<script>

  import { timeFix, getUrlQueryString } from '@/utils/util';

export default {
  name: "wxLogin",
  data(){
    return {
      message: "logging ... ..."
    }
  },
  created() {
    const redirectUrl = window.location.href;
    if (redirectUrl.indexOf('code') < 0) {
      this.message = "企业微信未返回code，系统异常...";
      return;
    }
    this.authLogin();
  },
  methods: {
    authLogin() {
      const code = this.$route.query.code;
      const target = this.$route.query.state;
      const jsonCode = { "code": code }
      this.$store
        .dispatch("wxLogin", jsonCode)
        .then(() => {
          this.$router.push({ path: this.buildTargetUrl(target) })
          this.$notification.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来`,
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    buildTargetUrl(target) {
      this.message = target;
      return "/" + target.replaceAll("-", "/");
    }
  },
}

</script>